import '../../../App.css';
import React, { useContext } from "react";
import { IoIosWarning } from "react-icons/io";
import { FaTimes } from 'react-icons/fa';
import { AdminContext } from '../../../context/AdminContext';
import { StyleContext } from '../../../context/StyleContext';

function ModalExcluirLayout({ closeModal }) {

    const { deletarLayout } = useContext(AdminContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    return (
        <div className="modal-novo">
            <div className="modal-interno-delete">
                <div className="modal-content-delete">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '20px', padding: '16px' }} className='border-bottom'>
                        <div>
                            <IoIosWarning style={{ color: '#FACC15', marginRight: '5px' }} /> Excluir layout
                        </div>
                        <button className='btn-fechar' onClick={() => closeModal(false)}>
                            <FaTimes />
                        </button>
                    </div>
                    <div style={{ padding: '16px' }} className='border-bottom'>
                        Tem certeza que deseja excluir esse layout?
                    </div>
                    <div className="content-buttons">
                        <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => closeModal(false)}>Cancelar</button>
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={() => deletarLayout()}>Excluir</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalExcluirLayout